import { Outlet, useLocation } from 'react-router-dom'
import { TeamsFiltration } from '../../../../components/Teams/TeamsFiltration'
import { FormBlock } from '../../../../common/FormGenerator'
import { getFormConfig } from '../../../../components/Teams/TeamsFiltration/settingsConfig'
import { FormProvider, useForm } from 'react-hook-form'
import { PageLayout } from '../../../../components/PageLayout'
import { TeamsTabs } from '../../../../components/Teams/TeamsTabs'
import { useLayoutEffect, useMemo } from 'react'

const normalizeStringValue = (value: string | null): string => value?.trim() ?? ''

export const TeamsLayout = () => {
  useLayoutEffect(() => {
    document.title = 'Команды'
  }, [])

  const { search } = useLocation()
  const defaultValues = useMemo(() => {
    const searchParams = new URLSearchParams(search)
    return {
      search: normalizeStringValue(searchParams.get('query')),
      regionTeam: normalizeStringValue(searchParams.get('region')) || 'all',
    }
  }, [search])

  const methods = useForm({ mode: 'all', defaultValues })

  return (
    <FormProvider {...methods}>
      <PageLayout
        title="Команды"
        mainComponent={<Outlet />}
        sideComponent={<TeamsFiltration />}
        searchComponent={<FormBlock formFieldConfig={getFormConfig('search')} />}
        topComponent={<TeamsTabs />}
      />
    </FormProvider>
  )
}
